import Vue from "vue";
import Router from "vue-router";
import AppHeaderWeb from "./layout/AppHeaderWeb";
import AppHeaderLogin from "./layout/AppHeaderLogin";
import AppHeaderMobile from "./layout/AppHeaderMobile";
import AppFooter from "./layout/AppFooter";
import Login from './views/Login/login'
import Customertransactions from "./views/Reports/CustomerTransactionsStatus/customertransactions"
import ProductReport from "./views/Reports/ProductReport/productreport"
import walletreport from "./views/Reports/WalletReport/walletreport"
import BalanceReport from "./views/Reports/BalanceReport/balancereport";
import ChangePassword from "./views/ChangePassword/changepassword";
import CompanyUser from "./views/CompanyUser/companyuser";
import SignUp from "./views/SignUp/signup";
import Developers from "./views/Developers/developers";
import Callback from './views/Callback'
import { userAuth } from './services/security'
import { Plugins } from '@capacitor/core';

const { App } = Plugins;

import config from "@/settings/config.js"
import invoicereport from "./views/Reports/InvoiceReport/invoicereport";



Vue.use(Router);

var header = AppHeaderWeb;
if (config.isMobile)
    header = AppHeaderMobile;

let router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [{
        path: '/',
        name: 'home',
        components: {
            header: AppHeaderLogin,
            default: Login,
            footer: AppFooter
        },
    },
    {
        path: "/login",
        name: "login",
        components: {
            header: AppHeaderLogin,
            default: Login,
            footer: AppFooter
        }
    },
    {
        path: "/signup",
        name: "signup",
        components: {
            header: AppHeaderLogin,
            default: SignUp,
            footer: AppFooter
        }
    },
    {
        path: "/landing",
        name: "landing",
        components: {
            header: AppHeaderLogin,
            default: Login,
            footer: AppFooter
        },
    },
    {
        path: '/callback',
        name: 'callback',
        components: {
            header: header,
            default: Callback
        }
    },
    {
        path: "/transactionstatus",
        name: "transactionstatus",
        components: {
            header: header,
            default: Customertransactions,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/invoicereport",
        name: "invoicereport",
        components: {
            header: header,
            default: invoicereport,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/productreport",
        name: "productreport",
        components: {
            header: header,
            default: ProductReport,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/walletreport",
        name: "walletreport",
        components: {
            header: header,
            default: walletreport,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/balancereport",
        name: "balancereport",
        components: {
            header: header,
            default: BalanceReport,
            //footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/changepassword",
        name: "ChangePassword",
        components: {
            header: header,
            default: ChangePassword,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/companyuser",
        name: "companyuser",
        components: {
            header: header,
            default: CompanyUser,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/developers",
        name: "developers",
        components: {
            header: header,
            default: Developers,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    }
    ]
})

export default router;

App.addListener('appUrlOpen', function (data) {
    const slug = data.url.split('/').pop();
    router.push({
        path: '/' + slug,
    });
});

router.beforeEach(async (to, from, next) => {
    let app = userAuth.data().user || { isAuthenticated: false }
    const role = userAuth.getAuthorised();
    let hasRole = false;
    if (role) {
        if (Array.isArray(role))
            hasRole = role.includes("Company_user");
        else
            hasRole = role === "Company_user";
    }
    if (app.isAuthenticated && hasRole) {
        next()
    } else if (to.matched.some(record => record.meta.requiresAuth)) {
        await userAuth.SignOut();
        next();
    } else {
        //No auth required. We can navigate
        next()
    }
});
